import React, { RefObject } from "react";
import { Query } from "@apollo/client/react/components";
import { gql } from "@apollo/client";
import { Select } from "antd";
import PageLoader from "../PageLoader";

const MIGRATIONS_QUERY = gql`
  query {
    projects {
      id
      company
    }
  }
`;

const { Option } = Select;

type ProjectSelectProps = {
  onChange?: any;
  value?: string;
  ref?: RefObject<any>;
};

React.createRef();

export default class ProjectSelect extends React.Component<ProjectSelectProps> {
  projectSelectOptions(projects: any[]): JSX.Element[] {
    let options = [];
    if (projects) {
      projects.forEach((project) => {
        options.push(
          <Option value={project.id} key={project.id} company={project.company}>
            {project.company}
          </Option>,
        );
      });
    }
    return options;
  }

  render() {
    return (
      <Query query={MIGRATIONS_QUERY}>
        {({ loading, data }) => {
          if (loading) {
            return <PageLoader tip="Loading..." delay={500} />;
          }

          data.projects
            .slice()
            .sort((a, b) => a.company.localeCompare(b.company));

          return (
            <Select
              showSearch
              key="projectId"
              optionFilterProp="children"
              value={this.props.value}
              onChange={this.props.onChange}
              ref={this.props.ref}
              filterOption={(input, option) =>
                option.props.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {this.projectSelectOptions(data.projects)}
            </Select>
          );
        }}
      </Query>
    );
  }
}
